import React from 'react';
import { Switch, Route } from 'react-router-dom';

import TikTok from './@tiktok';
import TikTok_Orders from './tiktok-orders'


import Error404 from '../Error404';


export default ({ match }) => {
    return (
        <Switch>
            <Route path={`${match.path}/at-tiktok`} component={TikTok} />
             <Route path={`${match.path}/tiktok-orders`} component={TikTok_Orders} />
            <Route component={Error404} />
        </Switch>
    )
}
